/**
 * API PATH CONFIGURATION
 * This file centralizes all API endpoints for the application.
 * It automatically switches between localhost and production server based on the environment.
 */

const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' || 
                    window.location.hostname === '[::1]' ||
                    window.location.hostname.match(/^\d+\.\d+\.\d+\.\d+$/) ||
                    window.location.hostname.endsWith('.local');

// Base URL for the API
export const API_BASE_URL = isLocalhost 
  ? `http://${window.location.hostname}:5000/api`
  : 'https://api.rupsaclinic.com/api';

// Auth Endpoints
export const LOGIN_ENDPOINT = `${API_BASE_URL}/auth/login`;
export const REGISTER_ENDPOINT = `${API_BASE_URL}/auth/register`;
export const PROFILE_ENDPOINT = `${API_BASE_URL}/auth/profile`;
export const CHANGE_PASSWORD_ENDPOINT = `${API_BASE_URL}/auth/change-password`;

// Resource Endpoints
export const DOCTORS_ENDPOINT = `${API_BASE_URL}/doctors`;
export const PATIENTS_ENDPOINT = `${API_BASE_URL}/patients`;
export const BOOKINGS_ENDPOINT = `${API_BASE_URL}/bookings`;
export const BILLS_ENDPOINT = `${API_BASE_URL}/bills`;

// Lab Report Endpoints
export const LABREPORTS_ENDPOINT = `${API_BASE_URL}/labreports`;
export const UPLOAD_LABREPORT_ENDPOINT = `${LABREPORTS_ENDPOINT}/upload`;
export const PATIENT_LABREPORTS_ENDPOINT = (patientId) => `${LABREPORTS_ENDPOINT}/patient/${patientId}`;

// Admin Dashboard Endpoints
export const ADMIN_BASE_ENDPOINT = `${API_BASE_URL}/admin`;
export const ADMIN_STATS_ENDPOINT = `${ADMIN_BASE_ENDPOINT}/stats`;
export const ADMIN_DOCTORS_ENDPOINT = `${ADMIN_BASE_ENDPOINT}/doctors`;
export const ADMIN_USERS_ENDPOINT = `${ADMIN_BASE_ENDPOINT}/users`;
export const ADMIN_BOOKINGS_ENDPOINT = `${ADMIN_BASE_ENDPOINT}/bookings`;
export const ADMIN_BILLS_ENDPOINT = `${ADMIN_BASE_ENDPOINT}/bills`;
export const ADMIN_RECENT_BILLS_ENDPOINT = `${ADMIN_BASE_ENDPOINT}/recent-bills`;
export const ADMIN_BILL_PDF_ENDPOINT = (billId) => `${ADMIN_BASE_ENDPOINT}/bills/${billId}/pdf`;

// Payment Endpoints
export const PAYMENTS_ENDPOINT = `${API_BASE_URL}/payments`;
export const CREATE_PAYMENT_ORDER_ENDPOINT = `${PAYMENTS_ENDPOINT}/create-order`;
export const VERIFY_PAYMENT_ENDPOINT = `${PAYMENTS_ENDPOINT}/verify`;
export const PAYMENT_STATUS_ENDPOINT = (bookingId) => `${PAYMENTS_ENDPOINT}/status/${bookingId}`;

// Useful for static file links (uploads)
export const API_ORIGIN = new URL(API_BASE_URL, window.location.origin).origin;
